<template>
  <a class="btn btn-lg btn-danger" :id="id">
    <i :class="icon"></i> {{ text }}
  </a>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    text: {
      type: String
    }
  }
};
</script>
